import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BrowserService } from './browser.service';

declare function require(string): string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  titleSuffix = 'Dash - The simple meeting room display';
  navbarOpen = false;
  imgs = new Array();
  loadedCount = 0;
  webpSupportLoaded = false;

  isLoaded = false;

  constructor(private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute, private browserService:BrowserService) {
    browserService.addLoadListener(() => {
      this.webpSupportLoaded = true;
      this.updateLoadedStatus();
    })
  }

  toggleNavbar() {
      this.navbarOpen = !this.navbarOpen;
  }

  closeNavbar() {
        this.navbarOpen = false;
  }

  updateLoadedStatus() {
    this.isLoaded = this.loadedCount >= this.imgs.length && this.webpSupportLoaded;
  }

  ngOnInit() {
      //angular doesn't support require on images anymore
      this.pload(
//         require('../assets/images/ipad-screen-1.png'),
//         require('../assets/images/ipad-screen-2.png'),
//         require('../assets/images/ipad-sidebar.png'),
      );
      const appTitle = this.titleService.getTitle();
      this.router
        .events.pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {
            const child = this.activatedRoute.firstChild;
            if (child.snapshot.data.title) {
              return child.snapshot.data.title + this.titleSuffix;
            }
            return appTitle;
          })
        ).subscribe((ttl: string) => {
          this.titleService.setTitle(ttl);
        });
  }


  pload(...args: any[]): void {
    const t = this;
    for (let i = 0; i < args.length; i++) {
      this.imgs[i] = new Image();
      this.imgs[i].addEventListener('load', (event) => {
        t.loadedCount = t.loadedCount + 1;
        this.updateLoadedStatus();
        console.log('loaded', event.target.src, t.loadedCount);
      }, false);
      this.imgs[i].src = args[i].default ? args[i].default : args[i];
    }
  }

}
